module.exports = __webpack_public_path__ + "static/media/medicalvr.c89b0e0f.jpg";